import { CdkScrollable } from '@angular/cdk/scrolling';
import { computed, Directive, effect, ElementRef, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScrollNavigationAnchor, ScrollNavigationService } from 'navigation-data';

@Directive({
  selector: '[idealNavAnchor]',
  standalone: true,
})
export class NavAnchorDirective implements ScrollNavigationAnchor {
  private readonly _scrollNavigationService = inject(ScrollNavigationService);

  public readonly container = inject(CdkScrollable);
  public readonly relativeTo = inject(ActivatedRoute);

  private readonly _elmRef = inject<ElementRef<HTMLElement>>(ElementRef);
  public get element() {
    return this._elmRef.nativeElement;
  }

  public readonly anchor = input<string | undefined>(undefined, { alias: 'idealNavAnchor' });
  public readonly navId = input<string>();
  public readonly navLabel = input<string>('');
  public readonly navDisabled = input<boolean>(false);
  public readonly navHeading = input<string>('');
  public readonly navHidden = input<boolean>(false);
  public readonly navReplaceUrl = input<boolean>(true);
  public readonly navPriority = input<number>();
  public readonly navIcon = input<string>();
  public readonly id = computed(() => {
    const anchor = this.anchor();
    if (!anchor) {
      return undefined;
    }
    const navId = this.navId();
    return navId ? `${navId}/${anchor}` : anchor;
  });

  constructor() {
    effect((clean) => {
      if (!this.id()) {
        return;
      }
      this._scrollNavigationService.anchorCreated(this);
      clean(() => {
        this._scrollNavigationService.anchorDestroyed(this);
      });
    });
  }
}
